// extracted by mini-css-extract-plugin
export var cCentered = "styles-module--c-centered--86fa0";